export interface FaqItem {
  id: string;
  question: string;
  answer: string;
  category: "Security" | "Execution" | "Stack" | "Retainer" | "Scope" | "Onboarding" | "Global";
}

export const contactFaqs: FaqItem[] = [
  {
    id: "privacy-ip",
    category: "Security",
    question: "How do you handle Data Privacy, IP Ownership, & Enterprise AI Compliance?",
    answer: "You retain 100% ownership of all intellectual property, source code, data pipelines, and trained model weights. All AI workflows are architected using zero-data-retention enterprise APIs (OpenAI Enterprise, Anthropic, AWS Bedrock) or self-hosted open-source models (Llama 3, DeepSeek) inside your private cloud VPC."
  },
  {
    id: "turnaround-async",
    category: "Execution",
    question: "What is the turnaround time & how does async execution work?",
    answer: "Deliverables are shipped in continuous 48–72 hour sprint cycles. Communication happens directly inside your dedicated Slack/Teams channel with daily video walkthroughs, clear PRs, and async updates—eliminating unnecessary status meetings."
  },
  {
    id: "tech-stack",
    category: "Stack",
    question: "What AI tech stack and frameworks do you build with?",
    answer: "Production systems are built using Next.js 16 (React 19), TypeScript, Python (FastAPI/LangGraph), PyTorch, Vector Databases (Pinecone, Qdrant, pgvector), Vercel AI SDK, and custom WebGL/WebGPU frontends for ultra-low latency rendering."
  },
  {
    id: "retainer-pause",
    category: "Retainer",
    question: "How does the $3,000/mo Engineering Partnership work & can I pause anytime?",
    answer: "The subscription is billed monthly with zero long-term lock-in. If you run out of active requests, you can pause your subscription with a single click in your customer portal and resume whenever you're ready to build again."
  },
  {
    id: "scope-flexibility",
    category: "Scope",
    question: "Do you build 0-to-1 products or embed into existing engineering teams?",
    answer: "Both. I build and launch complete turnkey software products from scratch, or embed directly into your existing engineering team to unblock critical features and accelerate development."
  },
  {
    id: "global-onsite",
    category: "Global",
    question: "Are you available for international travel, on-site kickoffs, or workshops?",
    answer: "Yes. While day-to-day delivery is remote-first for maximum speed, I am available worldwide for on-site sprints (architecture kickoffs, launch milestones, and team workshops). Requires 2–4 weeks prior notice, client travel coverage, and standard visa/invitation documentation."
  },
  {
    id: "onboarding-speed",
    category: "Onboarding",
    question: "How fast can onboarding happen after securing a slot?",
    answer: "Access to your dedicated Slack channel, private GitHub repository, and Linear board is provisioned within 24 hours of securing your partnership slot."
  }
];

export function getFaqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": contactFaqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}
